import React, { useRef, useEffect, useState, Suspense } from "react";
import { Button } from "reactstrap";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { safeAssetLoad } from "../utils/envUtils";
import { PDFErrorBoundary } from "./PDFErrorBoundary";

const RealiseCollectionPdfWebView = ({
  form,
  selecOffer,
  user,
  today,
  title,
}) => {
  const contentRef = useRef();
  const location = useLocation();
  const taday = moment(form.collection_date).format("Do MMMM, YYYY");
  const ignoreMDA =
    form.mda_name === "Ministry of Finance" ||
    form.mda_name === "Government House";

  // Check if current route is /signed-releases
  const isSignedReleasesRoute = title === "Signed Approvals";

  const handleDownload = async () => {
    try {
      // Dynamically import html2pdf
      const html2pdf = await import("html2pdf.js");

      const opt = {
        margin: 0,
        filename: "realise-collection.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["css", "legacy"] },
      };

      html2pdf.default().set(opt).from(contentRef.current).save();
    } catch (error) {
      console.error("PDF generation failed:", error);
      alert("PDF generation failed. Please try again.");
    }
  };

  const pageStyle = {
    width: "210mm",
    minHeight: "297mm",
    padding: "30px 40px",
    fontFamily: "Arial, sans-serif",
    fontSize: "11px",
    lineHeight: "1.4",
    backgroundColor: "white",
    margin: "0 auto 20px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    pageBreakAfter: "always",
    position: "relative",
  };

  const watermarkStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(-45deg)",
    fontSize: "48px",
    fontWeight: "bold",
    color: "rgba(0, 0, 0, 0.05)",
    whiteSpace: "nowrap",
    pointerEvents: "none",
    userSelect: "none",
    zIndex: 1,
  };

  const contentWrapperStyle = {
    position: "relative",
    zIndex: 2,
  };

  const renderPage = (isSecondPage = false) => (
    <div style={pageStyle}>
      {/* Watermark */}
      <div style={watermarkStyle}>Ministry of Budget and Economic Planning</div>

      {/* Content wrapper */}
      <div style={contentWrapperStyle}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <img
            src={require("../assets/images/pngwing.com.png")}
            style={{ width: "100px", height: "60px", marginBottom: "8px" }}
            alt="logo"
          />

          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "4px",
            }}
          >
            MINISTRY OF BUDGET & ECONOMIC PLANNING
          </div>
          <div style={{ fontSize: "12px", marginBottom: "2px" }}>
            Old Government House Office Complex, Katsina
          </div>
          <div style={{ fontSize: "12px" }}>P.MB 2132, KATSINA</div>
        </div>

        {/* Reference and Date */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "15px",
          }}
        >
          <div style={{ width: "70%" }}>Our Ref: {form.approval_no}</div>
          <div style={{ width: "30%", textAlign: "right" }}>{taday}</div>
        </div>

        {/* Address */}
        <div style={{ marginBottom: "15px" }}>
          <div>The Accountant General,</div>
          <div>Ministry of Finance,</div>
          <div>Katsina,</div>
        </div>

        {/* Subject */}
        <div
          style={{
            textAlign: "center",
            fontWeight: "bold",
            textDecoration: "underline",
            fontSize: "14px",
            marginBottom: "15px",
          }}
        >
          SPECIAL RELEASE OF FUNDS
        </div>

        {/* Body */}
        <div style={{ marginBottom: "15px" }}>
          <p>
            I am directed to convey approval for the release of{" "}
            <span style={{ fontWeight: "bold" }}>
              (N{selecOffer(form.approved_amount)}) only
            </span>{" "}
            to {form?.copies?.officeTitle}
            {form?.copies1?.officeTitle && form?.copies1?.officeTitle !== null
              ? " payable to "
              : ""}{" "}
            {form?.copies1?.officeTitle && form?.copies1?.officeTitle !== null
              ? form?.copies1?.officeTitle + " "
              : ""}
            {form.narration}.
          </p>

          <p style={{ marginTop: "10px", fontWeight: "bold" }}>
            The Vote of Charge is{" "}
            {form.project_type === "payable-to"
              ? form.send_to_office
              : form.mda_code}
            /
            {form.approval_type === "Recurrent"
              ? form.mda_economic_code
              : form.program_code}
            .
          </p>

          <p style={{ marginTop: "10px" }}>
            This letter is copied to{" "}
            {ignoreMDA ? "" : form?.copies?.officeTitle + ", "}
            {form?.copies1?.officeTitle
              ? form?.copies1?.officeTitle + ", "
              : ""}
            {form?.cc ? form?.cc + ", " : ""}
            the PS, (GHKT), the HC (MOF), the COS (GHKT), the Chairman (FRC),
            the Auditor-General, the Office of the Auditor-General for the
            State, the Chairman, and the Director Main Account, Ministry of
            Finance.
          </p>
        </div>

        {/* CC and Signature for first page */}
        {!isSecondPage && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "40px",
            }}
          >
            {/* {JSON.stringify(form)} */}
            {/* CC Section */}
            <div style={{ width: "60%", fontSize: "10px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "8px" }}>CC:</div>
              <div
                style={{
                  marginLeft: "15px",
                  fontStyle: "italic",
                  fontSize: "8px",
                }}
              >
                {!ignoreMDA && (
                  <>
                    <div style={{ marginBottom: "1px" }}>
                      {form?.copies?.officeTitle},
                    </div>
                    <div style={{ marginBottom: "1px" }}>Katsina,</div>
                  </>
                )}
                {form?.copies1?.officeTitle && (
                  <>
                    <div style={{ marginBottom: "1px" }}>
                      {form?.copies1?.officeTitle},
                    </div>
                    <div style={{ marginBottom: "1px" }}>Katsina,</div>
                  </>
                )}
                <div style={{ marginBottom: "1px" }}>
                  The Permanent Secretary, Government House, Katsina,
                </div>
                <div style={{ marginBottom: "1px" }}>
                  The Hon. Commissioner, Ministry of Finance, Katsina,
                </div>
                <div style={{ marginBottom: "1px" }}>
                  The Auditor General, Office of the Auditor-General for the
                  State, Katsina,
                </div>
                <div style={{ marginBottom: "1px" }}>
                  The Chief of staff, Government House, Katsina,
                </div>
                <div style={{ marginBottom: "1px" }}>
                  The Chairman, Fiscal Responsibility Commission, Katsina,
                </div>
                <div style={{ marginBottom: "1px" }}>
                  The Director Main-Account, Ministry of Finance, Katsina,
                </div>
                {form.cc && (
                  <div style={{ marginBottom: "1px" }}>{form.cc}, Katsina</div>
                )}
              </div>
            </div>

            {/* Signature */}
            <div
              style={{ width: "35%", textAlign: "right", alignItems: "right" }}
            >
              {(user?.imageURL || isSignedReleasesRoute) && (
                <img
                  src={user?.imageURL || ""}
                  style={{ width: "80px", height: "60px", marginBottom: "5px" }}
                  alt="signature"
                />
              )}
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "10px",
                  marginBottom: "2px",
                }}
              >
                {user?.name || ""}
              </div>
              <div style={{ fontWeight: "bold", fontSize: "9px" }}>
                DIRECTOR OF BUDGET
              </div>
              <div style={{ fontWeight: "bold", fontSize: "9px" }}>
                FOR: HON. COMMISSIONER
              </div>
            </div>
          </div>
        )}

        {/* Second page content */}
        {!isSecondPage && (
          <div style={{ marginTop: "30px", justifySelf: "right" }}>
            <div
              style={{
                textAlign: "center",
                fontSize: "10px",
                fontStyle: "italic",
                marginTop: "15px",
                marginBottom: "10px",
              }}
            >
              Above for your information and awareness, please.
            </div>
            <div
              style={{
                textAlign: "center",
                marginTop: "20px",
                alignItems: "flex-end",
                width: "100%",
              }}
            >
              <div
                style={{ width: "65%", alignItems: "end", marginLeft: "auto" }}
              >
                {(user?.imageURL || isSignedReleasesRoute) && (
                  <img
                    src={user?.imageURL || ""}
                    style={{
                      width: "80px",
                      height: "60px",
                      marginBottom: "5px",
                    }}
                    alt="signature"
                  />
                )}
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "10px",
                    marginBottom: "2px",
                    textAlign: "center",
                  }}
                >
                  {user?.name || ""}
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "9px",
                    textAlign: "center",
                  }}
                >
                  DIRECTOR OF BUDGET
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "9px",
                    textAlign: "center",
                  }}
                >
                  FOR: HON. COMMISSIONER
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Only signature for second page */}
        {isSecondPage && (
          <div
            style={{
              textAlign: "center",
              marginTop: "20px",
              alignItems: "flex-end",
              width: "100%",
            }}
          >
            <div
              style={{ width: "35%", alignItems: "center", margin: "0 auto" }}
            >
              {(user?.imageURL || isSignedReleasesRoute) && (
                <img
                  src={user?.imageURL || ""}
                  style={{ width: "60px", height: "40px", marginBottom: "5px" }}
                  alt="signature"
                />
              )}
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "10px",
                  marginBottom: "2px",
                  textAlign: "center",
                }}
              >
                {user?.name || ""}
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "9px",
                  textAlign: "center",
                }}
              >
                DIRECTOR OF BUDGET
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "9px",
                  textAlign: "center",
                }}
              >
                FOR: HON. COMMISSIONER
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <PDFErrorBoundary>
      <div
        style={{
          backgroundColor: "#f5f5f5",
          padding: "20px",
          minHeight: "100vh",
        }}
      >
        <div ref={contentRef}>
          {renderPage(false)}
          {renderPage(true)}
        </div>
      </div>
    </PDFErrorBoundary>
  );
};

export default RealiseCollectionPdfWebView;
